import { render, staticRenderFns } from "./StandappForgotPasswordComponent.vue?vue&type=template&id=9998887a&scoped=true&"
import script from "./StandappForgotPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./StandappForgotPasswordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9998887a",
  null
  
)

export default component.exports